import React from 'react';
import { Button } from 'antd';
import {
  HomeOutlined,
  ShoppingOutlined,
  ThunderboltFilled,
  PhoneOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

// Public 404 — blue brand (matches the marketing site). The electrical "blown
// fuse" nod ties the page to what Current Care actually does.
const NotFound = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 20px',
        background: 'linear-gradient(160deg, #f6f9fe 0%, #e9f3ff 55%, #d7e9ff 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* decorative brand glows */}
      <div
        style={{
          position: 'absolute',
          top: '-120px',
          right: '-80px',
          width: 320,
          height: 320,
          borderRadius: '50%',
          background: 'rgba(3, 99, 217, 0.10)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-140px',
          left: '-60px',
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'rgba(7, 153, 247, 0.10)',
        }}
      />

      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: 560,
          textAlign: 'center',
        }}
      >
        <img
          src="/images/currentcare-logo.png"
          alt="Current Care"
          style={{ height: 56, width: 'auto', marginBottom: 24 }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />

        {/* 404 with a lightning bolt standing in for the middle digit */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
            lineHeight: 1,
            marginBottom: 8,
          }}
        >
          <span style={{ ...bigDigit }}>4</span>
          <ThunderboltFilled style={{ fontSize: 'clamp(56px, 14vw, 108px)', color: '#f1a134' }} />
          <span style={{ ...bigDigit }}>4</span>
        </div>

        <h1
          style={{
            fontSize: 'clamp(20px, 4vw, 26px)',
            fontWeight: 700,
            color: '#08152b',
            margin: '8px 0 6px',
          }}
        >
          Looks like this page blew a fuse
        </h1>
        <p
          style={{
            fontSize: '1rem',
            color: '#64748b',
            maxWidth: 420,
            margin: '0 auto 28px',
            lineHeight: 1.6,
          }}
        >
          The page you're looking for doesn't exist or may have moved. Let's get you back to
          something that works.
        </p>

        <div
          style={{
            display: 'flex',
            gap: 12,
            flexWrap: 'wrap',
            justifyContent: 'center',
            marginBottom: 36,
          }}
        >
          <Link to="/">
            <Button type="primary" size="large" icon={<HomeOutlined />}>
              Back to Home
            </Button>
          </Link>
          <Link to="/products">
            <Button size="large" icon={<ShoppingOutlined />}>
              Browse Products
            </Button>
          </Link>
        </div>

        <div
          style={{
            display: 'inline-flex',
            flexWrap: 'wrap',
            gap: '10px 28px',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '14px 24px',
            background: '#ffffff',
            borderRadius: 14,
            border: '1px solid #e2e8f0',
            boxShadow: '0 8px 24px -12px rgba(15,23,42,0.15)',
          }}
        >
          <span style={{ color: '#94a3b8', fontSize: 13, fontWeight: 600 }}>Need help?</span>
          <a href="tel:+9779805446865" style={contactLink}>
            <PhoneOutlined style={{ color: '#0363d9' }} />
            +977 980-544-6865
          </a>
          <a href="mailto:info@currentcarenpl.com" style={contactLink}>
            <MailOutlined style={{ color: '#0363d9' }} />
            info@currentcarenpl.com
          </a>
        </div>
      </div>
    </div>
  );
};

const bigDigit = {
  fontSize: 'clamp(72px, 18vw, 140px)',
  fontWeight: 800,
  letterSpacing: '-4px',
  background: 'linear-gradient(135deg, #0363d9 0%, #0799f7 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

const contactLink = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  color: '#0f172a',
  fontSize: 14,
  fontWeight: 500,
  textDecoration: 'none',
};

export default NotFound;
